import styled from "styled-components/macro";
import { Text } from "@ds/react";

export const ContainerStyleSuccessScreen = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

export const StyleTitleSuccessScreen = styled(Text)(({ theme }) => ({
  color: theme.color.brandPrimary.medium,
  textTransform: "none",
  marginBottom: 24,
  lineHeight: "36px",
  [theme.breakpoint.lg()]: {
    lineHeight: "42px",
  },
}));

export const StyleDescriptionSuccessScreen = styled(Text)(({ theme }) => ({
  color: theme.color.neutral["02"],
  fontWeight: 700,
  lineHeight: "28.8px",
  [theme.breakpoint.lg()]: {
    lineHeight: "32px",
  },
}));

export const ContainerStyleSuccessScreenButton = styled.div(({ theme }) => ({
  marginTop: 40,
  marginBottom: 20,

  [theme.breakpoint.lg()]: {
    marginBottom: 0,
  },
}));
